import * as React from 'react';
export const argentaSvg = React.forwardRef(function argentaSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#068B4E',
        d: 'M0 0h32v32H0z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FFF',
        d: 'm15.95 8.7-1.45 1.45V5.8l1.45-1.45zm8.7 1.45H17.4l2.9-2.9h7.25zm-14.5 1.45L5.8 15.95v2.9l7.25-7.25zm8.7 0h-2.9L5.8 21.75v1.45l1.45 1.45 13.05-11.6zm4.35 4.35-1.45-1.45L8.7 26.1l1.45 1.45h4.35l8.7-8.7zm-3.625 11.6 3.19-3.19v-2.314l-5.468 5.504z',
      }),
    ),
  );
});
argentaSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  viewBox: '0 0 32 32',
};
export var argenta = {
  category: 'brand',
  colorable: false,
  name: 'argenta',
  svg: argentaSvg,
};
